import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navbar, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';

class Userinfo extends Component {
  render() {
    const { show, user } = this.props;

    if (show) {
      const tooltip = (
        <Tooltip id="tooltip">
          Company: <strong>{user.company}</strong>
        </Tooltip>
      );

      return (
        <div id="nav-userinfo">
          <Navbar.Text pullRight style={{ margin: 22 }}>
            <Glyphicon glyph="user" style={{ paddingRight: 10 }} />
            <OverlayTrigger placement="bottom" overlay={tooltip}>
              <strong className="green cursor-pointer">{user.name}</strong>
            </OverlayTrigger>
          </Navbar.Text>
        </div>
      );
    }

    return null;
  }
}

Userinfo.propTypes = {
  show: PropTypes.bool
};

function mapStateToProps({ user }) {
  return { user };
}

export default connect(mapStateToProps)(Userinfo);



// WEBPACK FOOTER //
// ./src/components/MainMenu/Userinfo.js